import { render, staticRenderFns } from "./VerificationComponent.vue?vue&type=template&id=50c636d1&scoped=true&"
import script from "./VerificationComponent.vue?vue&type=script&lang=js&"
export * from "./VerificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./VerificationComponent.vue?vue&type=style&index=0&id=50c636d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c636d1",
  null
  
)

export default component.exports